import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'

const OAUTH_TIMEOUT = 500

const OAUTH_SUCCESS = 'OAUTH_SUCCESS'
const OAUTH_ERROR = 'OAUTH_ERROR'

const OAuthCallback = () => {
  const [status, setStatus] = useState('processing')
  const location = useLocation()

  useEffect(() => {
    const handleOAuthCallback = () => {
      try {
        const urlParams = new URLSearchParams(location.search)

        const success = urlParams.get('success')

        if (!success || success !== 'true') {
          setStatus('error')

          if (window.opener) {
            window.opener.postMessage({ type: OAUTH_ERROR }, window.location.origin)
          }
        } else if (success && success === 'true') {
          setStatus('success')

          if (window.opener) {
            window.opener.postMessage(
              {
                type: OAUTH_SUCCESS,
              },
              window.location.origin,
            )
          }
        } else {
          setStatus('error')

          if (window.opener) {
            window.opener.postMessage(
              {
                type: OAUTH_ERROR,
              },
              window.location.origin,
            )
          }
        }

        setTimeout(() => {
          window.close()
        }, OAUTH_TIMEOUT)
      } catch (err) {
        console.error('OAuth callback error:', err)
        setStatus('error')

        if (window.opener) {
          window.opener.postMessage(
            {
              type: OAUTH_ERROR,
            },
            window.location.origin,
          )
        }

        setTimeout(() => {
          window.close()
        }, OAUTH_TIMEOUT)
      }
    }

    handleOAuthCallback()
  }, [location])

  return (
    <div className="oauth-callback">
      {status === 'processing' && (
        <div>
          <h2>Processing authentication...</h2>
          <p>Please wait while we complete your authentication.</p>
        </div>
      )}
      {status === 'success' && (
        <div className={`oauth-callback__${status}`}>
          <h2>✓ Authentication successful!</h2>
          <p>You can close this window.</p>
        </div>
      )}
      {status === 'error' && (
        <div className={`oauth-callback__${status}`}>
          <h2>✗ Authentication failed</h2>
          <p>Please try again or close this window.</p>
        </div>
      )}
    </div>
  )
}

OAuthCallback.propTypes = {
  router: PropTypes.object,
}

export default OAuthCallback
